import { Box, Typography } from '@mui/material';
import { NavWrapper } from 'src/components/common/NavWrapper';
import { LandingHeader } from 'src/components/landing/Header';
import { LandingFooter } from 'src/components/landing/Footer';
import { GetStaticProps } from 'next';
import { colors } from 'src/constants/colors';

const Legal = () => {
  return (
    <>
      <LandingHeader />
      <Box sx={{ backgroundColor: colors.lightBlack3, py: 5, px: 13 }}>
        <Typography fontWeight={600} fontSize={22} mb={3}>
          Disclaimer
        </Typography>
        <Typography></Typography>
        <Typography mb={2}>
          Investing in unregulated investments involves a high degree of risk.
          The value of an investment can go down as well as up and you could
          lose all of the money invested. Unregulated investments do not benefit
          from protections from the Financial Ombudsman Service or the Financial
          Services Compensation Scheme. If you are unsure as to whether an
          investment is suitable for you, you should seek independent
          professional advice prior to making an investment. Tax may be payable
          on any income or gains from these investments.
        </Typography>
        <Typography>
          {`Asset Tribe Management Sarl is a private limited liability company
            (société à responsabilité limitée) incorporated and existing under the
            laws of the Grand Duchy of Luxembourg, acting in its own capacity and
            as managing general partner (associé commandité) of Asset Tribe Fund
            SLP, a special limited partnership (société en commandite spéciale),
            qualifying as an investment company with variable capital reserved
            alternative investment fund (société d’investissement à capital
            variable – fonds d´investissement alternatif réservé) with several
            compartments, incorporated and existing under the laws of the Grand
            Duchy of Luxembourg.`}
        </Typography>
        <Typography fontWeight={600} fontSize={22} my={3}>
          Local Restrictions for customers of ATMS only:
        </Typography>
        <Typography>
          {`The distribution of material on this website may be restricted by the
            laws or regulations of the country from which you are accessing this
            website. The information on this website is not intended for
            distribution to or use by any person or entity in any jurisdiction or
            country where such distribution would be contrary to local law or
            regulation. We make no warranties that the materials on this website
            are appropriate or available for use in such locations.`}
        </Typography>
      </Box>
      <LandingFooter />
    </>
  );
};

export default Legal;

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      messages: {
        ...require(`../../locales/${context.locale}/shared.json`),
        ...require(`../../locales/${context.locale}/home.json`),
      },
      now: new Date().getTime(),
    },
  };
};
